import { render } from "./AddMessage.vue?vue&type=template&id=67bb8abe"
import script from "./AddMessage.vue?vue&type=script&lang=js"
export * from "./AddMessage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__